<div class="credit-transfer-section">
  <div class="form-container" [formGroup]="form" [ngSwitch]="currentView">
    <app-loading-animation *ngIf="loading"></app-loading-animation>

    <app-transfer-form-section
      (validateData)="validateData()"
      (validateSupportData)="validateSupportData()"
      (clearTheForm)="clearForm()"
      (updateSiteIdDisplay)="getSiteIdDisplay($event)"
      [siteIdDisplay]="siteIdDisplay"
      [products]="productsList"
      *ngSwitchCase="'form'"
    ></app-transfer-form-section>

    <app-transfer-review-section
      [(transferMessage)]="transferMessage"
      [form]="form"
      [productId]="productId"
      [products]="products"
      [siteIdDisplay]="siteIdDisplay"
      (submitSupportTransfer)="submitSupportTransfer()"
      (submitTransfer)="submitTransfer()"
      (viewToggler)="viewToggler()"
      *ngSwitchCase="'review'"
      [recipientName]="recipientName"
      [accountNumber]="accountNumber"
      [accountId]="accountId"
      [products]="productsList"
      (navigateToInventory)="handleNavigateToInventory()"
      (navigateToHistory)="handleNavigateToHistory()"
      (navigateToTransfer)="handleNavigateToTransfer()"
    ></app-transfer-review-section>
  </div>
</div>
